import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { RouterModule } from '@angular/router';

import {MatMenuModule} from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { TimeUpdatePipe } from 'src/app/pipes/timeUpdate';
import { MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { AvatarModule } from '../avatar/avatar.module';
import { ProfileModule } from '../profile/profile.module';
import { SearchComponent } from '../search/search.component';
import { ProfileMenuComponent } from '../profile-menu/profile-menu.component';
import { PipesModule } from 'src/app/pipes/pipes.module';


@NgModule({
  declarations: [
    MenuComponent,
        
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    SearchComponent,
    RouterModule,
    MatMenuModule,
    PipesModule,
    MatDialogModule,
    MatIconModule,
    ProfileMenuComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    PipesModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AvatarModule,
    FormsModule,
    ProfileModule
  ],
  exports: [
    MenuComponent
  ],
})
export class MenuModule { }
